
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

const initialValues = {
    fingerprint: "",
    cardLimit: "",
};

export default function Edit(props) {
    const token = useSelector((state) => state.auth.token);
    const {
        onHide,
        show,
        onFingerLimits,
        id,
        onFingerLimitChoose,
        skip,
        take,
        sortField,
        orderBy,
        filterInputs, } = props;
    const [isError, setIsError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const EditSchema = Yup.object().shape({
        cardLimit: Yup.string()
            .required('cardLimit tələb olunur.'),
        fingerprint: Yup.string()
            .required('fingerprint tələb olunur.'),
    })



    const onPutDuty = (cardLimit, fingerprint, resetForm, setSubmitting) => {
        setIsLoading(true);
        axios
            .put(
                `${process.env.REACT_APP_API_URL}user/limit/${id}?${cardLimit ? `&cardLimit=${cardLimit}` : ""
                }${fingerprint ? `&fingerprint=${fingerprint}` : ""
                }`,
                {
                    id,
                    cardLimit,
                    fingerprint
                },
                {
                    headers: { Authorization: `bearer ${token}` },
                }
            )
            .then(() => {
                onFingerLimits(orderBy, sortField, skip, take, filterInputs)
                resetForm();
                setSubmitting(false);
                onHide(false);
                setIsLoading(false);

            })
            .catch(
                ({
                    response: {
                        data: { message },
                    },
                }) => {
                    setIsError(message);
                    setIsLoading(false);

                }
            );
    };

    const getInputClasses = (filedName) => {
        if (formik.touched[filedName] && formik.errors[filedName]) {
            return true;
        }
        if (formik.touched[filedName] && !formik.errors[filedName]) {
            return false;
        }

        return false;
    };

    const formik = useFormik({
        initialValues,
        validationSchema: EditSchema,
        onSubmit: (values, { resetForm, setSubmitting }) => {
            onPutDuty(values.cardLimit, values.fingerprint, resetForm, setSubmitting);
        },
    });

    const resetForm = () => {
        onHide();
        formik.resetForm();
    };
    const { setFieldValue } = formik

    useEffect(() => {
        setIsLoading(true)
        onFingerLimitChoose(id)
            .then((res) => {
                setFieldValue('cardLimit', res.data.cardLimit)
                setFieldValue('fingerprint', res.data.fingerprint)
                setIsLoading(false)
                setIsError(false)
            })
            .catch((err) => {
                setIsLoading(false)
                setIsError(true)
            })
    }, [id, onFingerLimitChoose, setFieldValue])


    return (
        <Modal
            onHide={resetForm}
            show={show}
            size="sm"
            aria-labelledby="edit"
            centered
            className="modal pr-0"
        >
            <form onSubmit={formik.handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title id="Edit">Düzəliş et</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-12 pl-4 pr-4">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <TextField
                                        id="cardLimit"
                                        name="cardLimit"
                                        type='number'
                                        InputProps={{inputProps:{min:0}}}
                                        onKeyPress={(event) => {
                                            if (event?.key === '-' || event?.key === '+') {
                                              event.preventDefault();
                                            }
                                          }}
                                        label="Kart limiti"
                                        placeholder="Kart limiti"
                                        className="w-100"
                                        error={getInputClasses("cardLimit")}
                                        {...formik.getFieldProps("cardLimit")}
                                    />
                                </div>
                                {formik.touched.cardLimit && formik.errors.cardLimit ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">{formik.errors.cardLimit}</div>
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                                    <TextField
                                        id="fingerprint"
                                        name="fingerprint"
                                        type='number'
                                        InputProps={{inputProps:{min:0}}}
                                        onKeyPress={(event) => {
                                            if (event?.key === '-' || event?.key === '+') {
                                              event.preventDefault();
                                            }
                                          }}
                                        label="Barmaq izi"
                                        placeholder="Barmaq izi"
                                        className="w-100"
                                        error={getInputClasses("fingerprint")}
                                        {...formik.getFieldProps("fingerprint")}
                                    />
                                </div>
                                {formik.touched.fingerprint && formik.errors.fingerprint ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.fingerprint}
                                        </div>
                                    </div>
                                ) : null}
                                {isError && (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block MuiFormLabel-root Mui-error">
                                            {isError}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="light"
                        onClick={() => {
                            onHide(false);
                            formik.resetForm();
                        }}
                    >
                        Ləğv et
                    </Button>
                    <Button type="submit" className={isLoading ? "px-9" : ""}>
                        <span>Düzəliş et</span>
                        {isLoading && <span className="ml-3 spinner spinner-white"></span>}
                    </Button>

                </Modal.Footer>
            </form>
        </Modal>
    );
}
